<template>
  <transition name="router-anim">
    <div class="registration">

      <div class="card">
        <header class="card-header ">
          <img class="" :src="$t('logoUrl')" alt="logo" style="height:35px; margin: 5px auto;">
        </header>

        <div class="card-content">
          <div class="has-text-centered">
            <h3 class="title is-3">{{ $t('SignupThemeSelect.heading') }}</h3>
            <h3 class="subtitle" style="font-size:14px;">{{ $t('SignupThemeSelect.subtitle') }}</h3>
          </div>
               

          <div class="form">
            <section class="" style="height: 60vh;text-align: center;overflow:hidden;">
              <theme-chooser currentTheme="default" v-on:theme-select="themeSelect" />
            </section>
            
          </div>

        </div>
        <footer class="has-text-centered">
          <button class="button is-green" :class="{'is-loading':isLoading}" style="margin: 1rem;color:white!important;"
            @click="saveInfo">{{ $t('SignupPlaceInfo.continue') }}</button>
          <!-- <div id="status-message">
            <p>{{statusMessage}}</p>
          </div> -->
        </footer>

      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import _ from "underscore";
import ThemeChooser from "./themeChooser.vue";

export default {
  components: {
        ThemeChooser
  },

    computed: _.extend(
    {},
    mapGetters({
      info: "getPlaceInfo"
    }),
    {}
  ),

  data() {
    return {
      isLoading: false,
      themeChoice: "",
    };
  },
  methods: _.extend({}, mapActions(["populatePlaceInfo", "updatePlaceInfo"]), {
    saveInfo: function() {
      this.isLoading = !this.isLoading;
      this.$ma.trackEvent({
            category: "event",
            action: "Theme selected",
            properties: {context: this.themeChoice}
          });
      this.info.background = this.themeChoice;
      this.info.signupStep = "signup_3"
      this.updatePlaceInfo(this.info).then(() => {
        this.isLoading = !this.isLoading;
        // move to next step
        // let nextStep = "/dashboard?dialog=checklist"
        let nextStep = "/signup_" + (parseInt(this.$route.path.split("_").pop())+2).toString() //TODO: skipping step 3
        this.$router.replace(nextStep);
      });
    },
    themeSelect: function(themeName) {
      console.log(themeName)
      this.themeChoice = themeName;
      this.$ma.trackEvent({
            category: "event",
            action: "Scrolled to theme",
            properties: {context: themeName}
          });
    },
    }),
  mounted() {
    window.onbeforeunload = function() {
      return "Are you sure you want to exit?";
    };
    
    this.$title = this.$t('title') + " | " + this.$t('Signup.title')
    this.$ma.trackEvent({category: 'event', action: 'Page viewed: ' + this.$route.fullPath, label : null, value : null})
  }
}
</script>

<style scoped>
html {
    overflow: hidden!important;
}
body {
    background: #fff!important;
  }

.url-input {
  margin: 3rem auto;
  max-width: 70%;
}

.card {
  min-height: 70vh;
}

footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #8080805c;
}

.form{
  width: 60%;
  margin: 2rem auto 2rem;
}
@media screen and (min-width:768px) {
 .card-content {
    margin-top: 5vh;
  }
}
@media screen and (max-width:768px) {


 .form{
      width: 80%;
      margin: 1.5rem auto 0px;

  }
  .registration .field:not(:last-child) {
      margin-bottom: 0.75rem;
  }


  .label:not(:last-child) {
    margin-bottom: 0;
  }

  .card {
    min-height: 100vh;
  }
}
@supports (-webkit-appearance:none) {
    .card {
      min-height: calc(100vh - 56px);
    }
}
</style>

